// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"cc19d57f","917":"edc3499f"}[chunkId] + ".chunk.js";
};